export default __webpack_public_path__ + "static/media/product-document--green.14baf239.svg";